__turbopack_context__.v({
  "callout": "personal-route-module__jb5Enq__callout",
  "calloutBody": "personal-route-module__jb5Enq__calloutBody",
  "compare": "personal-route-module__jb5Enq__compare",
  "compareChip": "personal-route-module__jb5Enq__compareChip",
  "compareRing": "personal-route-module__jb5Enq__compareRing",
  "dot": "personal-route-module__jb5Enq__dot",
  "fadeIn": "personal-route-module__jb5Enq__fadeIn",
  "insetIn": "personal-route-module__jb5Enq__insetIn",
  "knob": "personal-route-module__jb5Enq__knob",
  "more": "personal-route-module__jb5Enq__more",
  "pulse": "personal-route-module__jb5Enq__pulse",
  "reason": "personal-route-module__jb5Enq__reason",
  "reasonArrow": "personal-route-module__jb5Enq__reasonArrow",
  "reasonIcon": "personal-route-module__jb5Enq__reasonIcon",
  "reasonRow": "personal-route-module__jb5Enq__reasonRow",
  "reasons": "personal-route-module__jb5Enq__reasons",
  "relight": "personal-route-module__jb5Enq__relight",
  "root": "personal-route-module__jb5Enq__root",
  "sentence": "personal-route-module__jb5Enq__sentence",
  "sliders": "personal-route-module__jb5Enq__sliders",
  "sonar": "personal-route-module__jb5Enq__sonar",
  "stop": "personal-route-module__jb5Enq__stop",
  "strip": "personal-route-module__jb5Enq__strip",
  "track": "personal-route-module__jb5Enq__track",
});
